export function distance(x1: number, y1: number, x2: number, y2: number): number {
	return Math.sqrt(Math.abs(x1 - x2) ** 2 + Math.abs(y1 - y2) ** 2)
}

export function clamp(val: number, min: number, max: number): number {
	return Math.min(Math.max(val, min), max)
}

export function lerp(from: number, to: number, at: number): number {
	return from + ((to - from) * at)
}